import Api from "./api";

class CategoryService {

    api = new Api();

    getCategoryInfo(catId) {
        return this.api.post('/admin/category/get-category-info', {
            catId: catId
        });
    }

    removeCategoryImage(imageId) {
        return this.api.post('/admin/category/remove-category-image', {
            imageId: imageId
        });
    }

    addCategoryImage(catId, src) {
        return this.api.post('/admin/category/add-category-image', {
            catId: catId,
            src: src
        });
    }

    getCategoryImage(catId) {
        return this.api.post('/admin/category/get-category-image', {
            catId: catId
        });
    }

    updateCategoryDescription(catId, description) {
        return this.api.post('/admin/category/update-category-description', {
            catId: catId,
            description: description
        });
    }

    getCategory(catId) {
        return this.api.get('/catalog/category/get-category', {
            catId: catId
        });
    }

    getAvailableAttributes(catId, selectedAttributes) {
        return this.api.post('/catalog/category/get-available-attributes', {
            catId: catId,
            selectedAttributes: selectedAttributes
        });
    }

    search(name) {
        return this.api.post('/catalog/category/search-categories', {
            name: name
        });
    }
}

export default new CategoryService();


